<template>
  <div>
    <iframe frameborder="0" width="100%" height="100%" :src="url"></iframe>
  </div>
</template>

<script>
export default {
  name: 'IFrame',
  data() {
    return {
      //链接地址
      url: ''
    }
  },
  mounted () {
    //获取路径
    let url = this.$route.query.url;
    this.url = url ? url : '/#/404';
  }
}
</script>



// WEBPACK FOOTER //
// src/views/main/IFrame.vue